export const viewTitle = "Справочник мест хранения";
export const viewUniqKey = "storage";
